export default __webpack_public_path__ + "static/media/tic-tac-toe.6818e5f2.svg";